import { FolderPermissionLevel, FolderPermissionReadAccess, PermissionScope } from '../../../../../api/types.gen';
import { IPermissionsDialogForm } from '../PermissionsDialogForm';

type GetFormStateFromPermissionLevelReturn = Partial<IPermissionsDialogForm>;

export function getFormStateFromPermissionLevel(input: FolderPermissionLevel): GetFormStateFromPermissionLevelReturn {
  switch (input) {
    case FolderPermissionLevel.NONE:
      return getLevelNoneState();
    case FolderPermissionLevel.OWNER:
      return getLevelOwnerState();
    case FolderPermissionLevel.PUBLISHING_EDITOR:
      return getLevelPublishingEditorState();
    case FolderPermissionLevel.EDITOR:
      return getLevelEditorState();
    case FolderPermissionLevel.PUBLISHING_AUTHOR:
      return getLevelNonePublishingAuthorState();
    case FolderPermissionLevel.NONEDITING_AUTHOR:
      return getLevelNoneditingAuthorState();
    case FolderPermissionLevel.REVIEWER:
      return getLevelReviewerState();
    case FolderPermissionLevel.CONTRIBUTOR:
      return getLevelContributorState();
    case FolderPermissionLevel.AUTHOR:
      return getLevelAuthorState();
    case FolderPermissionLevel.FREE_BUSY_TIME_ONLY:
      return getLevelFreeBusyTimeOnlyState();
    case FolderPermissionLevel.FREE_BUSY_TIME_AND_SUBJECT_AND_LOCATION:
      return getLevelFreeBusyTimeAndSubjectAndLocationState();
    default:
      return {};
  }
}

export function getLevelNoneState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.NONE,
    deleteItems: PermissionScope.NONE,
    canCreateItems: false,
    canCreateSubfolders: false,
    editItems: PermissionScope.NONE,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: false,
  };
}

function getLevelOwnerState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.ALL,
    canCreateItems: true,
    canCreateSubfolders: true,
    editItems: PermissionScope.ALL,
    isFolderContact: true,
    isFolderOwner: true,
    isFolderVisible: true,
  };
}

function getLevelPublishingEditorState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.ALL,
    canCreateItems: true,
    canCreateSubfolders: true,
    editItems: PermissionScope.ALL,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelEditorState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.ALL,
    canCreateItems: true,
    canCreateSubfolders: false,
    editItems: PermissionScope.ALL,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelNonePublishingAuthorState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.OWNED,
    canCreateItems: true,
    canCreateSubfolders: true,
    editItems: PermissionScope.OWNED,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelAuthorState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.OWNED,
    canCreateItems: true,
    canCreateSubfolders: false,
    editItems: PermissionScope.OWNED,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelNoneditingAuthorState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.OWNED,
    canCreateItems: true,
    canCreateSubfolders: false,
    editItems: PermissionScope.NONE,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelReviewerState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.FULL_DETAILS,
    deleteItems: PermissionScope.NONE,
    canCreateItems: false,
    canCreateSubfolders: false,
    editItems: PermissionScope.NONE,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelContributorState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.NONE,
    deleteItems: PermissionScope.NONE,
    canCreateItems: true,
    canCreateSubfolders: false,
    editItems: PermissionScope.NONE,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: true,
  };
}

function getLevelFreeBusyTimeOnlyState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.TIME_ONLY,
    deleteItems: PermissionScope.NONE,
    canCreateItems: false,
    canCreateSubfolders: false,
    editItems: PermissionScope.NONE,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: false,
  };
}

function getLevelFreeBusyTimeAndSubjectAndLocationState(): GetFormStateFromPermissionLevelReturn {
  return {
    readItems: FolderPermissionReadAccess.TIME_AND_SUBJECT_AND_LOCATION,
    deleteItems: PermissionScope.NONE,
    canCreateItems: false,
    canCreateSubfolders: false,
    editItems: PermissionScope.NONE,
    isFolderContact: false,
    isFolderOwner: false,
    isFolderVisible: false,
  };
}
